import { z, type ZodType } from 'zod'

/**
 * 範例：{ a : { b : { view:true } } }
 */

export function getPermissionDataSchema<T extends ZodType>(value: T) {
  return z.record(
    z.string(),
    z.record(z.string(), z.record(value as any, z.boolean()))
  )
}
